<template>

    <el-form-item :label="$t('c.knowledgePoint')">
        <el-popover
            placement="bottom"
            width="240"
            trigger="click">
            <div class="knowledge-tree">
                <el-tree
                    id="know"
                    ref="tree"
                    :data="knowledgeData"
                    :props="defaultProps"
                    show-checkbox
                    node-key="id"
                    accordion
                    :default-expanded-keys="[0]"
                    @check-change="checkChange"
                    :getCheckedNodes="value"
                    :expand-on-click-node="false"
                    :render-content="renderContent">
                </el-tree>
            </div>
                <el-input slot="reference" v-model="knowledgeNames" :placeholder="$t('tip.knowledgePoint')" collapse-tags readonly="readonly"></el-input>

        </el-popover>
    </el-form-item>
</template>

<script>
    import api from '@/api';
    import {mapGetters} from 'vuex';

    export default {
        props: {
            isSystem:false,
            type: {
                default: 'All'
            }
        },
        data() {
            return {
                kpIds: [],
                value: '',
                knowledgeNames:'',
                knowledgeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'value'
                },
            }
        },
        created() {
            if(this.isSystem){
                this.$store.dispatch('getSystemKnowledgeMenu', {
                    type: this.type,
                    includeSafty: true
                }).then(data => {
                    this.knowledgeData = [{id: 0, value: this.$t('c.all'), children: data}];
                    this.$nextTick(() => {
                        $('.knowledge-tree .el-tree > .el-tree-node').find('.el-checkbox:eq(0)').click();
                    });
                });

            }else{
                this.$store.dispatch('getKnowledgeMenu', {
                    type: this.type,
                    includeSafty: true
                }).then(data => {
                    this.knowledgeData = [{id: 0, value: this.$t('c.all'), children: this.knowledgeMenu[this.type]}];
                    this.$nextTick(() => {
                        $('.knowledge-tree .el-tree > .el-tree-node').find('.el-checkbox:eq(0)').click();
                    });
                });
            }

        },
        mounted(){
//            this.$nextTick(()=>{
//                setTimeout(()=> {
//                    $('.el-tree > .el-tree-node').find('.el-checkbox:eq(0)').click();
//                },300)
//            })
        },
        computed: {
            ...mapGetters([
                'systemKnowledgeMenu','knowledgeMenu'
            ])
        },
        methods: {
            renderContent(h, {node, data, store}) {
                return (<span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;"><span><span>{node.label}</span></span></span>);
            },
            checkChange (val, checked, nodeChecked) {
                this.kpIds = this.$refs.tree.getCheckedKeys()
                this.$emit('knowledgeChange', this.kpIds);
                let nodeNames=this.$refs.tree.getCheckedNodes();
                let newBox=[]
                nodeNames.forEach(item=>{
                    if(item.children){
                        item.children.forEach(item2=>{
                            newBox.push(item2.value)
                        })
                    }
                    newBox.push(item.value)
                })
                this.knowledgeNames = this.deleteSame(newBox).join(', ')
            },
            deleteSame(array){
                let r = [];
                let tt=[]
                for (let i = 0, l = array.length; i < l; i++) {
                    for (let j = i + 1; j < l; j++){
                        if (array[i] === array[j]){
                            tt.push(array[i])
                            j = ++i;
                        }
                    }
                    r.push(array[i]);
                }
                tt.forEach(item=>{
                    r.splice(r.indexOf(item),1)
                })
                return r;
            },
            getIds (data) {
                let that = this

                function getChildids(arr) {
                    let idsArr = []
                    arr.forEach(item => {
                        if (item.children) {
                            idsArr.push(item.id)
                            idsArr = idsArr.concat(getChildids(item.children))
                        } else {
                            idsArr.push(item.id)
                        }
                    })
                    return idsArr
                }

                function getIds(data) {
                    let ids = [data.id]
                    ids = ids.concat(getChildids(data.children))
                    return ids
                }

                return getIds(data)
            },

            reset() {
                this.kpIds = []
                this.knowledgeNames = ''

                this.knowledgeData = [{id: 0, value: this.$t('c.all'), children: this.knowledgeMenu[this.type]}];
                this.$nextTick(() => {
                    $('.knowledge-tree .el-tree > .el-tree-node').find('.el-checkbox:eq(0)').click();
                });
            }
        },
        watch: {
        },
        components: {}
    }
</script>

<style  lang="scss">
    @import "../style/const";

    .knowledge-tree {
        margin-right: -10px;
        margin-bottom: -5px;
        @include scrollbar(#ccc, 10px);
    }

    #know {
        @include scrollbar(#ccc, 8px, 10px);
        max-height: 470px;
        overflow-y: auto;

        .el-tree-node .el-tree-node__children{
            overflow: auto;
        }
    }
</style>

